// ==========================================================================
// Header Navigation
// ==========================================================================

class HeaderNav {
	constructor() {
		this.header = document.querySelector('.header');
		this.menuBtn = document.querySelector('.header_btn_toggle');
		this.menuPanel = document.querySelector('.header_menu');
		this.init();
	}

	init() {
		if (!this.menuBtn || !this.menuPanel) return;

		// ハンバーガーメニューのクリックイベント
		this.menuBtn.addEventListener('click', () => {
			this.toggleMenu();
		});

		// スクロールリンクの処理
		this.initScrollLinks();

		// メニュー外クリックで閉じる
		document.addEventListener('click', (e) => {
			if (this.isMenuOpen() &&
				!this.menuPanel.contains(e.target) &&
				!this.menuBtn.contains(e.target)) {
				this.closeMenu();
			}
		});

		// ESCキーで閉じる
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.isMenuOpen()) {
				this.closeMenu();
			}
		});
	}

	initScrollLinks() {
		// ヘッダーナビゲーションとハンバーガーメニューのリンク
		const scrollLinks = document.querySelectorAll('[data-scroll-target]');

		scrollLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				const target = link.getAttribute('data-scroll-target');
				const tab = link.getAttribute('data-tab');

				if (target) {
					e.preventDefault();

					// メニューを閉じる
					if (this.isMenuOpen()) {
						this.closeMenu();
					}

					// タブパラメータがある場合は処理
					if (tab) {
						this.scrollToProductsWithTab(target, tab);
					} else {
						this.scrollToSection(target);
					}
				}
			});
		});
	}

	scrollToProductsWithTab(targetId, tab) {
		// URLパラメータを更新
		const url = new URL(window.location);
		url.searchParams.set('tab', tab);
		window.history.pushState({}, '', url);

		// カスタムイベントを発火してタブ切り替えを通知
		const event = new CustomEvent('switchProductTab', { detail: { tab } });
		window.dispatchEvent(event);

		// スクロール
		setTimeout(() => {
			this.scrollToSection(targetId);
		}, 100);
	}

	scrollToSection(targetId) {
		const targetElement = document.getElementById(targetId);
		if (!targetElement) return;

		// ヘッダーの高さを取得
		const headerHeight = this.header ? this.header.offsetHeight : 0;
		const offset = 20; // 追加のオフセット

		console.log(`Header height: ${headerHeight}px, Offset: ${offset}px`);

		// スクロール位置を計算
		const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
		const offsetPosition = elementPosition - headerHeight - offset;

		// スムーススクロール
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}

	toggleMenu() {
		const isOpen = this.isMenuOpen();
		if (isOpen) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		this.menuBtn.setAttribute('aria-expanded', 'true');
		this.menuBtn.setAttribute('aria-label', 'メニューを閉じる');
		this.menuPanel.setAttribute('aria-hidden', 'false');
		document.body.style.overflow = 'hidden';
	}

	closeMenu() {
		this.menuBtn.setAttribute('aria-expanded', 'false');
		this.menuBtn.setAttribute('aria-label', 'メニューを開く');
		this.menuPanel.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
	}

	isMenuOpen() {
		return this.menuBtn.getAttribute('aria-expanded') === 'true';
	}
}

// DOMContentLoaded後に初期化
document.addEventListener('DOMContentLoaded', () => {
	new HeaderNav();
});
